import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { PrivateRoute } from './routes/PrivateRoute/PrivateRoute';
import './App.scss';
import store from '@progressivebeef/shared/src/store/react';

import ACTION_CONSTANTS from '@progressivebeef/shared/src/constants/actionConstants';

import Login from './screens/app/Login';
import ForgotPassword from './screens/app/Login/ForgotPassword';
import Logout from './screens/app/Login/Logout';
import GeneratePin from './screens/app/Login/GeneratePin';
import LockScreen from './screens/app/Login/LockScreen';
import Activities from './screens/app/Activities';
import FeedyardList from './screens/app/FeedyardList';
import SwitchFeedyard from './screens/app/FeedyardList';
import Dashboard from './screens/app/Dashboard';
import Coachmark from './screens/app/Coachmark';
import Notification from './screens/app/Dashboard/Notification';
import ActivityPerformance from './screens/app/Dashboard/ActivityPerformance';
import BackDatedSubmissions from './screens/app/Dashboard/BackDatedSubmissions';
import ExportCompliance from './screens/app/Dashboard/ExportCompliance';
import ActiveWorkers from './screens/app/Dashboard/ActiveWorkers';
import PendingActions from './screens/app/Dashboard/PendingActions';
import Filter from './screens/app/Activities/filter';
import ActivityBin from './screens/app/Activities/activityBin';
import SubmissionList from './screens/app/Activities/SubmissionList';
import ActivityTagList from './components/ActivityTagList';
import Print from './screens/app/Activities/Print';
import AssignLog from './screens/app/Activities/AssignLog';
import Schedule from './screens/app/Activities/Schedule';
import ProgramManuals from './screens/app/ProgramManuals';
import ProgramManualBin from './screens/app/ProgramManuals/ProgramManualBin';
import ProgramManualDetail from './screens/app/ProgramManuals/ProgramManualDetail';
import ViewDocument from './screens/app/ProgramManuals/ViewDocument';
import AddDocument from './screens/app/ProgramManuals/AddDocument';
import Instance from './screens/app/Activities/Instance';
import RemovedInstance from './screens/app/Activities/Instance/RemovedInstance';
import Settings from './screens/app/Settings';
import AppTrainingVideoHtml from './screens/app/AppTrainingVideoHTML';
import Users from './screens/app/Users';
import AddSubmission from './screens/app/Activities/AddSubmission';
import AddEditUser from './screens/app/Users/AddEditUser';
import NavigationVideo from './screens/app/NavigationVideo/NavigationVideos';
import ChangePassword from './screens/app/Settings/ChangePassword';
import ChangePin from './screens/app/Settings/ChangePin';
import VideoPlayer from './components/VideoPlayer';
import Audits from './screens/app/Audit/Audits';
import AuditNCList from './screens/app/Audit/AuditNCList';
import NCDetail from './screens/app/Audit/NCDetail';
import AuditReport from './screens/app/Audit/AuditReport';
import RecordBinder from './screens/app/RecordBinder';
import RecordBinderDetail from './screens/app/RecordBinder/RecordBinderDetail';
import AddRecord from './screens/app/RecordBinder/AddRecord';
import RecordBinderBin from './screens/app/RecordBinder/RecordBinderBin';
import { useIdleTimer } from 'react-idle-timer';
import ROUTE_CONSTANTS from '@progressivebeef/shared/src/constants/RouteConstants';
import {
  IDLE_TIME,
  LOCAL_STORAGE_KEYS,
} from '@progressivebeef/shared/src/constants/AppConstants';
import ServerError from './screens/app/ServerError';
import ServerNotResponding from './screens/app/ServerNotResponding';
import ViewDocumentReport from './components/ViewDocument';
import AlertService from '@progressivebeef/shared/src/services/AlertService';
import AlertModal from './components/AlertModal';
import NavigationHandler from './components/NavigationHandler';
import { useNavigate, useLocation } from 'react-router-dom';

const afterEveryMins = 10 * 1000 * 60;

// Create a wrapper component for the idle timer hook
const IdleTimerWrapper = ({ children, onIdle, timeout, debounce, events }) => {
  useIdleTimer({
    onIdle,
    timeout,
    debounce,
    events
  });

  return children;
};

// Hook-based component to handle navigation and location
const AppWithHooks = ({ handleIdle }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleIdleWithNavigation = () => {
    if (
      location.pathname !== ROUTE_CONSTANTS.LOGIN &&
      location.pathname !== ROUTE_CONSTANTS.FORGOT_PASSWORD &&
      location.pathname !== ROUTE_CONSTANTS.GENERATE_PIN &&
      location.pathname !== ROUTE_CONSTANTS.LOGOUT &&
      location.pathname !== ROUTE_CONSTANTS.FEEDYARD_LIST
    ) {
      navigate(ROUTE_CONSTANTS.LOCK_SCREEN);
      store.dispatch({
        type: ACTION_CONSTANTS.SHOW_LOCK_SCREEN,
      });
    }
  };

  return (
    <IdleTimerWrapper
      timeout={IDLE_TIME}
      onIdle={handleIdleWithNavigation}
      debounce={250}
      events={[
        'keydown',
        'wheel',
        'DOMMouseScroll',
        'mousewheel',
        'mousedown',
        'touchstart',
        'touchmove',
        'MSPointerDown',
        'visibilitychange',
      ]}
    >
      <NavigationHandler />
      <Routes>
        <Route path="/ServerError" element={<ServerError />} />
        <Route path="/ServerNotResponding" element={<ServerNotResponding />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        
        <Route path="/Logout" element={<PrivateRoute><Logout /></PrivateRoute>} />
        <Route path="/GeneratePin" element={<PrivateRoute><GeneratePin /></PrivateRoute>} />
        <Route path="/LockScreen" element={<LockScreen />} />
        <Route path="/Dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/Coachmark" element={<PrivateRoute><Coachmark /></PrivateRoute>} />
        <Route path="/Notification" element={<PrivateRoute><Notification /></PrivateRoute>} />
        <Route path="/BackDatedSubmissions" element={<PrivateRoute><BackDatedSubmissions /></PrivateRoute>} />
        <Route path="/ActivityPerformance" element={<PrivateRoute><ActivityPerformance /></PrivateRoute>} />
        <Route path="/ExportCompliance" element={<PrivateRoute><ExportCompliance /></PrivateRoute>} />
        <Route path="/ActiveWorkers" element={<PrivateRoute><ActiveWorkers /></PrivateRoute>} />
        <Route path="/PendingActions" element={<PrivateRoute><PendingActions /></PrivateRoute>} />
        <Route path="/RecordBinder" element={<PrivateRoute><RecordBinder /></PrivateRoute>} />
        <Route path="/RecordDetail" element={<PrivateRoute><RecordBinderDetail /></PrivateRoute>} />
        <Route path="/RecordBin" element={<PrivateRoute><RecordBinderBin /></PrivateRoute>} />
        <Route path="/AddRecord" element={<PrivateRoute><AddRecord /></PrivateRoute>} />
        <Route path="/Activities" element={<PrivateRoute><Activities /></PrivateRoute>} />
        <Route path="/Filter" element={<PrivateRoute><Filter /></PrivateRoute>} />
        <Route path="/AddSubmission" element={<PrivateRoute><AddSubmission /></PrivateRoute>} />
        <Route path="/Print" element={<PrivateRoute><Print /></PrivateRoute>} />
        <Route path="/ActivityBin" element={<PrivateRoute><ActivityBin /></PrivateRoute>} />
        <Route path="/ActivityTagList" element={<PrivateRoute><ActivityTagList /></PrivateRoute>} />
        <Route path="/AssignLog" element={<PrivateRoute><AssignLog /></PrivateRoute>} />
        <Route path="/Schedule" element={<PrivateRoute><Schedule /></PrivateRoute>} />
        <Route path="/Instance" element={<PrivateRoute><Instance /></PrivateRoute>} />
        <Route path="/RemovedInstance" element={<PrivateRoute><RemovedInstance /></PrivateRoute>} />
        <Route path="/ViewDocumentReport" element={<PrivateRoute><ViewDocumentReport /></PrivateRoute>} />
        <Route path="/SubmissionList" element={<PrivateRoute><SubmissionList /></PrivateRoute>} />
        <Route path="/ProgramManual" element={<PrivateRoute><ProgramManuals /></PrivateRoute>} />
        <Route path="/ProgramManualBin" element={<PrivateRoute><ProgramManualBin /></PrivateRoute>} />
        <Route path="/ProgramManualDetail" element={<PrivateRoute><ProgramManualDetail /></PrivateRoute>} />
        <Route path="/ViewDocument" element={<PrivateRoute><ViewDocument /></PrivateRoute>} />
        <Route path="/AddDocument" element={<PrivateRoute><AddDocument /></PrivateRoute>} />
        <Route path="/SwitchFeedyard" element={<PrivateRoute><SwitchFeedyard /></PrivateRoute>} />
        <Route path="/ChangePassword" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
        <Route path="/ChangePin" element={<PrivateRoute><ChangePin /></PrivateRoute>} />
        <Route path="/FeedyardList" element={<PrivateRoute><FeedyardList /></PrivateRoute>} />
        <Route path="/Settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/Users" element={<PrivateRoute><Users /></PrivateRoute>} />
        <Route path="/AddUser" element={<PrivateRoute><AddEditUser /></PrivateRoute>} />
        <Route path="/EditUser" element={<PrivateRoute><AddEditUser /></PrivateRoute>} />
        <Route path="/NavigationVideos" element={<PrivateRoute><NavigationVideo /></PrivateRoute>} />
        <Route path="/VideoPlayer" element={<PrivateRoute><VideoPlayer /></PrivateRoute>} />
        <Route path="/Audits" element={<PrivateRoute><Audits /></PrivateRoute>} />
        <Route path="/AuditNCList" element={<PrivateRoute><AuditNCList /></PrivateRoute>} />
        <Route path="/NCDetail" element={<PrivateRoute><NCDetail /></PrivateRoute>} />
        <Route path="/AuditReport" element={<PrivateRoute><AuditReport /></PrivateRoute>} />
        <Route path="/AppTrainingVideoHtml" element={<PrivateRoute><AppTrainingVideoHtml /></PrivateRoute>} />
        
        {/* Default route - redirect to Dashboard */}
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      </Routes>
    </IdleTimerWrapper>
  );
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isConnected: navigator.onLine,
    };
    this.idleTimer = React.createRef();
    store.dispatch({
      type: ACTION_CONSTANTS.GET_INITIALIZED,
    });
  }

  componentDidMount() {
    AlertService.alertModal = AlertModal;

    //only for app launch
    let { isLogin, user, selectedFeedyard } = store.getState().authentication;
    this.setState({
      isLogin,
      user,
      selectedFeedyard,
    });
    this.handleConnectionChange();
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);
    window.addEventListener('storage', this.handleStorageChange);

    setInterval(() => {
      //code that will be called every 3 seconds
      const isLoggedIn = store.getState().authentication.isLogin;
      const feedyardSelected = store.getState().authentication.selectedFeedyard;
      if (isLoggedIn && feedyardSelected) {
        store.dispatch({
          type: ACTION_CONSTANTS.SYNC_DATA_NON_BLOCKING_REQUEST,
          payload: { isAutoSync: true },
        });
      }
    }, afterEveryMins);

    setTimeout(() => {
      store.dispatch({
        type: ACTION_CONSTANTS.HIDE_RANK_CARD,
      });
    }, 70000);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleConnectionChange);
    window.removeEventListener('offline', this.handleConnectionChange);
    window.removeEventListener('storage', this.handleStorageChange);
  }

  handleStorageChange = (e) => {
    // Check if the selected feedyard changed in another tab
    if (
      e.key === LOCAL_STORAGE_KEYS.FEEDYARD_CHANGED_AT &&
      e.newValue !== e.oldValue
    ) {
      window.location.reload();
    }
  };

  handleConnectionChange = () => {
    const condition = navigator.onLine ? 'online' : 'offline';
    if (condition === 'online') {
      this.setState({
        isConnected: true,
      });
      const isLoggedIn = store.getState().authentication.isLogin;
      const feedyardSelected = store.getState().authentication.selectedFeedyard;
      const syncPending = store.getState().dataSync.syncPending;
      if (isLoggedIn && feedyardSelected) {
        store.dispatch({
          type: ACTION_CONSTANTS.POST_PENDING_ACTIVITY_SUBMISSIONS_REQUEST,
        });
        if (syncPending) {
          store.dispatch({
            type: ACTION_CONSTANTS.SYNC_DATA_NON_BLOCKING_REQUEST,
            payload: { isAutoSync: true },
          });
        }
      }
      return;
    }
    return this.setState({ isConnected: false });
  };

  render() {
    return <AppWithHooks handleIdle={this.handleIdle} />;
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);